import { dateRange, digitsContains, inIds, inList, textContains, toListKey } from "./filterFns";

const FILTER_FNS = { list: inList, date: dateRange, text: textContains, digits: digitsContains, ids: inIds };
export const DEFAULT_WIDTH = 120;

export const getPath = (row, path) =>
    path.split(".").reduce((value, part) => (value === null || value === undefined ? undefined : value[part]), row);

export const toDate = (value) => {
    if (value === null || value === undefined || value === "") return undefined;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date;
};

export const formatDate = (value) => {
    const date = toDate(value);
    return date ? date.toLocaleDateString("pt-BR") : "";
};

/** Texto exibido para um valor: célula padrão, chips e export. */
export const displayValue = (config, value, row) => {
    if (config.format) return config.format(value, row) ?? "";
    if (config.labels) return config.labels[toListKey(value)] ?? toListKey(value);
    if (config.type === "date") return formatDate(value);
    return value === null || value === undefined ? "" : value;
};

/** Rótulo de uma opção do filtro lista (a chave é sempre string). */
export const listLabel = (config, key) => {
    if (key === "") return "(vazio)";
    if (config.labels && key in config.labels) return String(config.labels[key]);
    return key;
};

export const buildColumnDefs = (columns) =>
    columns.map((config) => {
        const baseAccessor = config.accessor ?? ((row) => getPath(row, config.key));
        const accessorFn = config.type === "date" ? (row) => toDate(baseAccessor(row)) : baseAccessor;
        return {
            id: config.key,
            accessorFn,
            header: config.header ?? "",
            cell: (context) =>
                config.cell
                    ? config.cell({ value: context.getValue(), row: context.row.original })
                    : displayValue(config, context.getValue(), context.row.original),
            size: config.width ?? DEFAULT_WIDTH,
            minSize: 40,
            maxSize: 2000,
            enableSorting: config.sortable !== false,
            enableHiding: config.hideable !== false,
            enableResizing: config.resizable !== false,
            enableColumnFilter: Boolean(config.filter),
            filterFn: config.filter ? FILTER_FNS[config.filter] : undefined,
            sortingFn: config.type === "date" ? "datetime" : "auto",
            sortUndefined: "last",
            meta: { config },
        };
    });

/** Todas as colunas-folha na ordem atual (inclui ocultas). */
export const orderedLeafColumns = (table) => {
    const order = table.getState().columnOrder ?? [];
    const position = (id) => {
        const index = order.indexOf(id);
        return index === -1 ? Number.MAX_SAFE_INTEGER : index;
    };
    return [...table.getAllLeafColumns()].sort((a, b) => position(a.id) - position(b.id));
};
